import styles from './ProvisionalFileView.module.scss';

const ProvisionalFileStatusNote = ({ message, details = [] }: { message: string; details?: string[] }) => (
    <>
        <p className={styles.StatusNote}>{message}</p>
        {details.length > 0 && (
            <ul className={styles.StatusNoteDetails}>
                {details.map((detail, index) => (
                    <li key={`${index}-${detail}`}>{detail}</li>
                ))}
            </ul>
        )}
    </>
);

export default ProvisionalFileStatusNote;
